export default "__VITE_ASSET__71edcee1__"